// Recovered compiled webpack factory 81402. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { s: () => s });
  var n = i(73142);
  function s(t) {
    return (0, n.G)(t) && "offsetHeight" in t && !("ownerSVGElement" in t);
  }
}
